import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  winnerString: string;
  showWinnerUserModal: boolean;
  data: any;
  users: any;
  public genders: any;
  public municipalities: any;
  searchParamsForm: FormGroup;
  usersData: any;
  usersCount: any;
  apiUrl: any;
  defaultloadSettings: any = {};
  public globalError: boolean = false;
  public sideBarStatus: string = 'show-sidebar';
  public queryParams: string = '';
  public relevatDateQueryParams: any = ['dateTime[$gt]', 'dateTime[$lt]', 'dateOfBirth[$gt]', 'dateOfBirth[$lt]', 'createdAt[$gt]', 'createdAt[$lt]'];
  public relevantQueryParams:string = 'municipality age gender';
  searchUsersField:boolean = true;
  searchVisitsField:boolean = false;
  public loggedInUserEmail: string = localStorage.getItem('email');
  public winner:string = 'vinnaren är: ';
  public isCreatingReport: boolean = false;
  public noReportsFound: boolean = false;
  public disableWinnerButton: boolean = false;

  constructor(private apiService: ApiService, private formBuilder: FormBuilder, private router: Router) {

    this.searchParamsForm = this.formBuilder.group({
      'dateTime[$gt]':[null],
      'dateTime[$lt]':[null],
      'dateOfBirth[$gt]':[null],
      'dateOfBirth[$lt]':[null],
      'createdAt[$gt]':[null],
      'createdAt[$lt]':[null],
      municipality:[null],
      gender:[null],
      age:[null],
      csvOutput:[true],
      active:[true]
    });

    this.apiUrl = this.apiService.getApiUrl();
    this.getMunicipalities();
    this.getGenders();
   }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.resetForm();
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    this.router.navigateByUrl('login');
  }

  removeParams(params){
    for (var key in params){
      if (params[key] == null){
        delete params[key]
      }
    }
  }

  formatBeginningOfSearchString(params){
    if(this.searchUsersField){
      this.queryParams = this.queryParams.concat('users?');
      if(params.active){
        this.queryParams = this.queryParams.concat('active=true')
      }
    }
    if(!this.searchUsersField&&this.searchVisitsField){
      this.queryParams = this.queryParams.concat('visits?');
    }
  }
//checks if date related query params have been set and adds them to the search request
formatDatetoSearchString(params){
  for (var key2 in params){
    if(this.relevatDateQueryParams.indexOf(key2)!=-1){
      console.log(params[key2]);
      
        let dateFormatted = new Date(params[key2]).toISOString();
        if(this.queryParams.substr(this.queryParams.length-1) == '?'){
          this.queryParams = this.queryParams.concat(key2,'=',dateFormatted);
        }
        else{
        this.queryParams = this.queryParams.concat('&',key2,'=',dateFormatted);
        }
    }
  }
}
//checks if query params have been set and adds them to the search request
  formatSearchString(params){
    for (var key2 in params){
      if(this.relevantQueryParams.indexOf(key2)> -1){
        this.queryParams = this.queryParams.concat('&',key2,'=',params[key2]);
      }
    }
  }

  saveParams(){
    if(!(this.searchUsersField||this.searchVisitsField)){
      alert("Sök antingen bland Använadare eller Besökare")
      return
    }
    //format params to match db seach conditions
    this.formatBeginningOfSearchString(this.searchParamsForm.value);
    this.removeParams(this.searchParamsForm.value);
    this.formatDatetoSearchString(this.searchParamsForm.value);
    this.formatSearchString(this.searchParamsForm.value);

    if(this.searchParamsForm.value.csvOutput){
      this.getCsvData(this.queryParams)
    }
    else{
    this.getData(this.queryParams)
    }
  }

  // Get the to the data !!! Still here if we want to expand and display data in the interface
  getData(queryParams) {
    this.apiService.get(queryParams).then((response:any) => {
      this.data = response.data;
      this.queryParams = '';
      if(this.data.length == 0){
        alert('ingen uppfyller dessa krav')
      }
      //flush query params
      this.queryParams ='';
      if(this.data.length > 0){
        console.log(this.data);
      }

    }).catch((err) => {
      this.queryParams  = '';
    });
  }

  getCsvData(queryParams) {
    this.noReportsFound = false;
    this.isCreatingReport = true;
    //exclude mannually deleted users
    // queryParams = queryParams.concat('&','firstName[$ne]=','manually deleted user',);
    this.apiService.getCsvFormat(queryParams).then((response:any) => {
    this.usersData = response;
    //flush query params
    this.queryParams = '';

      var a = document.createElement("a");
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      var blob = new Blob([this.usersData._body], { type: 'text/csv' });
      var url= window.URL.createObjectURL(blob);
      a.href = url;
      if(this.searchVisitsField){
        a.download = 'RapportBesökare' + new Date().toJSON().slice(0,10).replace(/-/g,'/') +  '.csv';
      }
      if(this.searchUsersField){
        a.download = 'RapportAnvändare' + new Date().toJSON().slice(0,10).replace(/-/g,'/') +  '.csv';
      }
      if(!(this.searchUsersField||this.searchVisitsField)){
        a.download = 'Export' + new Date().toJSON().slice(0,10).replace(/-/g,'/') +  '.csv';
      }
      a.click();
      this.isCreatingReport = false;

  }).catch((err) => {
    this.queryParams = '';
    if(err.status==404){
    this.noReportsFound = true;
    this.isCreatingReport = false;
    }
    else{
      this.globalError = true;
    }
  });
}
  // Get the municipalities and append them to the municipalities select box in the params form
  getMunicipalities() {
    this.apiService.get('municipalities').then((response:any) => {
      this.municipalities = response.data;
    }).catch((err) => {
    });
  }

  // Get the genders and append them to the genders select box in the params form
  getGenders() {
    this.apiService.get('genders').then((response:any) => {
      this.genders = response.data;
      for (let i = 0; i < this.genders.length; i++) {
        if(this.genders[i].gender == 'other') {
          this.genders[i].genderName = 'Ospecificerat';
        } else if(this.genders[i].gender == 'male') {
          this.genders[i].genderName = 'Man';
        } else if(this.genders[i].gender == 'female') {
          this.genders[i].genderName = 'Kvinna';
        }
      }
    }).catch((err) => {
    });
  }

  // Find new winner
  findNewWinner(){
    this.showWinnerUserModal=true;

    this.apiService.post('winners').then((response:any)=>{
      if(response.message){
        this.winnerString = 'Omöjligt att dra en ny vinnare. Samtliga personer som är inloggade har vunnit.';
      } else {
        this.winnerString = this.winner.concat(response.userName.userName , ' Förnamn: ' ,response.userName.firstName);
      }
    })
  }

  // Toggle sidebar
  toggleSidebar() {
    this.sideBarStatus = (this.sideBarStatus == 'hide-sidebar' ? 'show-sidebar' : 'hide-sidebar');
  }

  resetForm(){
    this.searchParamsForm.reset();
    this.searchParamsForm.controls['active'].setValue(true);
    this.searchParamsForm.controls['csvOutput'].setValue(true);
    this.searchParamsForm.controls['municipality'].setValue(null);
    this.searchParamsForm.controls['gender'].setValue(null);
    this.searchParamsForm.controls['age'].setValue(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts